import React, { useContext } from "react";
import { useSelector } from "react-redux";
// import RootState from '../../../../../../redux/types';
import "./FlierTwoIndex.css";
import { RavenButton } from "@ravenpay/raven-bank-ui";
import QRCode from "react-qr-code";
import supportIcons from "../../../../assets/support-icon-images.png";
import RootState from "../../../../redux/types";
import ActionContext from "../../../../context/ActionContext";

interface MyComponentProps {
  color_code?: string;
}

const FlierTwoIndex = (_props: MyComponentProps) => {
  const actionCtx = useContext(ActionContext);
  const { insight_terminal } = useSelector(
    (state: RootState) => state.insights
  );
  const { color_code } = _props;
  const ravenWhiteLogo = (
    <svg
      width="97"
      height="22"
      viewBox="0 0 97 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="img"
    >
      <path
        d="M28.1441 8.04396C28.155 8.05789 28.1763 8.10115 28.2105 8.12877C29.8366 9.45477 30.1369 11.3483 28.939 13.0745C27.9251 14.5353 26.5106 15.3082 24.7114 15.2895C23.4819 15.2768 22.2526 15.2386 21.0249 15.1844C20.5705 15.1645 20.1995 15.253 19.8322 15.5489C19.1502 16.099 18.3447 16.4092 17.3784 16.6024C17.4527 16.3598 17.4934 16.1761 17.5646 16.0052C18.2369 14.3885 18.9157 12.7743 19.5886 11.1571C19.6807 10.9358 19.7495 10.7049 19.8293 10.4785C19.785 10.4511 19.7402 10.4232 19.696 10.3959C19.5918 10.5168 19.4685 10.6259 19.3865 10.7598C18.8867 11.5745 18.4067 12.4004 17.8993 13.2101C17.5736 13.73 17.2322 14.2423 16.8647 14.7337C15.4488 16.6268 13.5225 17.6288 11.2026 17.926C10.9321 17.9604 10.6615 17.9948 10.3901 18.021C10.3259 18.0269 10.2586 17.9989 10.0883 17.9668C11.3377 16.0738 12.6116 14.2572 13.8582 12.4227C15.0899 10.6097 16.324 8.79856 17.5575 6.98679C17.5094 6.94753 17.4613 6.90826 17.4127 6.86957C17.2573 7.0435 17.0932 7.21068 16.9483 7.3932C15.8004 8.83594 14.6653 10.2885 13.5082 11.7239C12.1491 13.4095 10.7138 15.0254 9.0328 16.4051C7.46579 17.6909 5.75324 18.6972 3.74805 19.1353C2.57914 19.3909 0.935976 19.3641 0.00534949 19.0684C0.0465121 18.7638 0.314843 18.6387 0.507764 18.4777C1.61001 17.5603 2.7306 16.6648 3.83455 15.7498C8.2388 12.1015 12.4815 8.27857 16.3613 4.06808C17.0861 3.28165 17.7976 2.48122 18.4818 1.65988C18.7767 1.30623 19.1123 1.17232 19.5508 1.18942C21.8242 1.28073 24.0985 1.36081 26.3718 1.45981C26.8002 1.4784 27.2373 1.5227 27.6495 1.63266C30.1278 2.29489 30.9303 4.84648 29.2862 6.82795C28.9397 7.2459 28.5429 7.62156 28.1436 8.04335L28.1441 8.04396ZM20.9913 13.1586C21.1573 13.2166 21.24 13.2693 21.3234 13.2717C22.2985 13.2932 23.2739 13.3254 24.2486 13.3174C24.933 13.3118 25.4532 12.9503 25.8515 12.4182C26.2153 11.9321 26.3856 11.3753 26.3922 10.7653C26.4013 9.87218 25.8584 9.12467 24.9845 9.04318C23.9281 8.94469 22.86 8.96673 21.7021 8.93411C21.4616 10.3645 21.2268 11.7583 20.9907 13.158L20.9913 13.1586ZM22.0683 6.93558C23.1474 6.96599 24.169 7.08008 25.1749 6.99883C26.1551 6.91982 26.8911 5.77648 26.802 4.71475C26.7254 3.79674 26.1369 3.33941 24.9686 3.30234C24.3779 3.28392 23.7864 3.27258 23.1957 3.27608C22.7151 3.27913 22.6513 3.33716 22.567 3.80456C22.4463 4.47472 22.3343 5.14691 22.2253 5.81918C22.1686 6.17006 22.1255 6.5231 22.0683 6.93558Z"
        fill="white"
      />
      <path
        d="M42.0895 5.22143L40.4687 14.8094L37.4279 14.7238L37.7323 12.8775C36.8668 14.2038 35.7678 14.8571 34.4543 14.8201C32.6371 14.7689 30.3521 13.4261 30.9598 9.75191C31.5695 6.00555 34.3935 4.82509 36.2652 4.87782C37.3627 4.90875 38.2141 5.3646 38.8562 6.22924L39.0487 5.13635L42.0895 5.22202L42.0895 5.22143ZM38.121 10.5834L38.5082 8.3432C38.0725 7.19647 37.4766 6.60327 36.7391 6.58249C36.1093 6.56474 35.5431 6.85506 35.0216 7.47009C34.5184 8.06787 34.1718 8.86851 34.0178 9.85467C33.8659 10.7686 33.8985 11.5438 34.1324 12.1807C34.3845 12.8181 34.7897 13.1358 35.3834 13.1526C36.3009 13.1784 37.2077 12.3219 38.121 10.5828L38.121 10.5834Z"
        fill="white"
      />
      <path
        d="M52.8946 9.01903L51.8581 15.1301L48.8173 15.0444L49.833 9.04058C49.9315 8.089 49.9823 6.9382 48.9748 6.90982C48.0751 6.88446 47.1679 7.77713 46.2708 9.57053L45.3628 14.9471L42.322 14.8614L43.9429 5.2734L46.9836 5.35907L46.6803 7.16921C47.5636 5.86178 48.6799 5.22678 50.0289 5.26479C52.1338 5.3241 53.2436 6.85 52.894 9.01901L52.8946 9.01903Z"
        fill="white"
      />
      <path
        d="M60.6236 9.50807L63.3908 15.4562L59.954 15.3593L58.3739 11.3712L57.2668 12.3121L56.7694 15.269L53.7109 15.1828L56.0212 1.56339L59.0619 1.64907L57.6997 9.73195L62.3846 5.79415L64.8317 5.8631L60.6236 9.50807Z"
        fill="white"
      />
      <path
        d="M75.0801 12.1303C74.8886 13.1693 74.3788 14.0193 73.5493 14.6985C72.7198 15.3771 71.7204 15.6914 70.5874 15.6594L64.7581 15.4952L66.9373 2.69964L72.2091 2.84818C74.6384 2.91663 75.9316 4.30375 75.5865 6.31057C75.3919 7.45731 74.7373 8.33932 73.6038 8.9377C74.7404 9.49164 75.3195 10.6785 75.0801 12.1303ZM73.1191 12.075C73.4809 10.1042 72.0733 9.5788 71.2991 9.55699L67.7368 9.45661L66.8959 14.367L70.4765 14.4679C71.2324 14.4892 72.8121 14.0113 73.1191 12.0756L73.1191 12.075ZM67.9325 8.27377L71.2431 8.36705C71.9807 8.38783 73.3409 8.04821 73.6438 6.25583C73.9477 4.42794 72.7154 4.05081 71.9418 4.02901L68.6672 3.93675L67.9331 8.27378L67.9325 8.27377Z"
        fill="white"
      />
      <path
        d="M77.4053 14.6075C76.6224 13.6311 76.3682 12.4356 76.6064 11.0015C76.8442 9.58588 77.5075 8.41561 78.5963 7.49252C79.7028 6.56934 80.9573 6.13669 82.3608 6.17623C83.7642 6.21578 84.8485 6.71433 85.6131 7.69023C86.3959 8.66666 86.6502 9.86218 86.4124 11.2778C86.1736 12.7118 85.5109 13.8815 84.4221 14.8052C83.3339 15.7289 82.0788 16.1615 80.6753 16.122C79.2719 16.0825 78.1876 15.5839 77.4047 14.6075L77.4053 14.6075ZM83.1685 13.9233C83.874 13.169 84.3131 12.2809 84.5052 11.2241C84.6785 10.1846 84.5416 9.28027 84.0775 8.51128C83.6317 7.72445 82.9942 7.32853 82.1666 7.30522C81.3391 7.2819 80.5726 7.63825 79.8671 8.39265C79.1621 9.12928 78.723 10.0168 78.5314 11.0558C78.3577 12.1131 78.4939 13.0174 78.9403 13.8042C79.405 14.5738 80.0419 14.9697 80.8695 14.993C81.697 15.0163 82.4635 14.66 83.1685 13.9233Z"
        fill="white"
      />
      <path
        d="M90.1146 11.5272L87.4654 6.50061L89.7686 6.56551L91.6502 10.0936L94.951 6.71153L96.3906 6.75209L92.1653 11.0085L94.878 16.3431L92.5932 16.2788L90.6481 12.4604L87.1598 16.1257L85.7386 16.0856L90.1169 11.5272L90.1146 11.5272Z"
        fill="white"
      />
    </svg>
  );

  // const supportIcons =

  // const { profile } = useSelector((state: RootState) => state.settings);
  function downloadCanvas() {
    // Get the HTML content to convert to canvas
    const htmlContent = document.getElementById("htmlContent");
    // Convert HTML content to canvas using html2canvas library
	if (htmlContent) {
		html2canvas(htmlContent).then((canvas: any) => {
		//   const ctx = canvas.getContext('2d')!;
		  const secondCanvas = document.createElement('canvas');
		  const secondCtx = secondCanvas.getContext('2d')!;
	
		  secondCanvas.width = canvas.width;
		  secondCanvas.height = canvas.height;
	
		  secondCtx.fillStyle = 'white'; // Set the background color of the second canvas
		  secondCtx.fillRect(0, 0, secondCanvas.width, secondCanvas.height);
		  secondCtx.globalCompositeOperation = 'source-over';
		  secondCtx.drawImage(canvas, 0, 0);
	
		  secondCtx.globalCompositeOperation = 'source-over'; // Change blend mode here
		  secondCtx.drawImage(canvas, 0, 0);
	
		  const finalDataURL = secondCanvas.toDataURL('image/png');
	
		  // Create a link element to trigger the download
		  const link = document.createElement('a');
		  link.download = 'BankBox-flier.png'; // Set the filename
		  link.href = finalDataURL; // Set the data URL as the href attribute
		  // Simulate a click event to trigger the download
		  link.click();
		});
	  }
	
  }


  function hexToRgba(hex: any, opacity: any) {
    // Remove the "#" if present
    hex = hex.replace("#", "");

    // Parse the hexadecimal color
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Lighten the color by mixing it with white
    const lightenedR = Math.round(r + (255 - r) * opacity);
    const lightenedG = Math.round(g + (255 - g) * opacity);
    const lightenedB = Math.round(b + (255 - b) * opacity);

    // Construct the rgba color
    const rgbaColor = `rgba(${lightenedR}, ${lightenedG}, ${lightenedB}, 1)`;
    return rgbaColor;
  }

  return (
    <>
      <div
        // ref={webpageRef}
        id="htmlContent"
        className={`Flier-two-terminal-index-wrap`}
        onClick={() => {
          // console.log(config);
        //   console.log(actionCtx?.configDetails);
        }}
        style={{ backgroundColor: color_code && color_code }}
      >
        {/* business logo box start */}
        <div className="business-logo-box">
          {/* <figure className="img-box">
						<img
							className="img"
							src={profile?.businessInfo?.business_logo}
							alt=""
						/>
					</figure> */}
          {!actionCtx?.configDetails?.partnerInfo?.logo_url ? (
            <figure
              className="img-box"
              // style={{
              // 	backgroundImage: `url(${actionCtx?.configDetails?.partnerInfo?.logo_url})`,
              // }}
            >
              <img
                className="img"
                src={actionCtx?.configDetails?.partnerInfo?.logo_url}
                alt=""
              />
            </figure>
          ) : (
            <figure className="img-box-two">{ravenWhiteLogo}</figure>
          )}
        </div>
        {/* business logo box end */}
        {/* account detail sbox start */}
        <div className="account-detail-box-wrap">
          <div className="bank-name">
            <p className="bank">Bank Name</p>
            <p className="value">{insight_terminal?.terminalData?.account_info?.bank}</p>
          </div>
          {/* mascot account number box start */}
          <div className="mascot-account-number-box">
            <div
              className="account-detail"
              style={{
                backgroundColor: color_code && hexToRgba(color_code, 0.15),
              }}
            >
              <p className="account">ACCOUNT NUMBER</p>
              <p className="value">
                {insight_terminal?.terminalData?.account_info?.account_number}
              </p>
            </div>
          </div>
          {/* mascot account number box end */}
          <div className="bank-name account-name-box">
            <p className="bank">Account Name</p>
            <p className="value">
              {insight_terminal?.terminalData?.account_info?.account_name}
            </p>
          </div>
        </div>
        {/* account detail sbox end */}

        {/* qr code text box start */}
        <div className="qr-code-text-box-wrap">
          <div className="qr-code-box">
            <div className="qr">
              <QRCode value={`https://link.raventrust.com.ng/bankbox`} />
            </div>
          </div>
          <div className="bank-name">
            <p className="bank">Can’t Transfer?</p>
            <p className="value">
              Scan this QR code to pay with a <br /> different payment option
            </p>
          </div>
        </div>
        {/* qr code text box end */}
        <div className="underline"></div>
        {/* support box start */}
        <div className="we-support-box">
          <p className="text">We Support</p>
          <div className="support-img-box">
            <figure className="img-box">
              <img src={supportIcons} alt="" />
            </figure>
          </div>
        </div>
        {/* support box end */}
      </div>
      <div className={`border-theme flier_download_btn`}>
        <RavenButton
          color="deep-green-light"
          label="Download Flier"
          onClick={() => {
            downloadCanvas();
          }}
        />
      </div>
    </>
  );
};

export default FlierTwoIndex;
